import React from "react";
import styles from "./OfferTitleCell.module.css";
import {OfferInListDTO} from "../../../../../../../api/generated";
import {useAppDispatch} from "../../../../../../../app/hooks";
import classnames from "classnames";
import {openPopupModal, PopupModalName} from "../../../../../../elements/popupModalProvider/popupModalSlice";

interface OfferTitleCellProps {
    offer: OfferInListDTO
}

export const OfferTitleCell: React.FC<OfferTitleCellProps> = ({offer}) => {

    const isLargeDescription = offer.description.length > 70;

    const dispatch = useAppDispatch()

    const getDescription = () => {
        if (isLargeDescription) {
            return offer.description.substring(0, 70) + "...";
        }
        return offer.description;
    }

    const handleDescriptionClick = () => {
        if (isLargeDescription) {
            dispatch(openPopupModal({
                name: PopupModalName.VIEW_MORE,
                popupModalProps: {
                    value: offer.description,
                    title: "Offer description"
                }
            }))
        }
    }

    return <div className={styles.wrapper}>
        <span className={styles.title}>{offer.title}</span>
        <span
            className={classnames(styles.description, isLargeDescription && styles.largeDescription)}
            onClick={handleDescriptionClick}
        >{getDescription()}</span>
    </div>
}
